import {
  CrudFilters,
  CrudSort,
  CrudSorting,
  LogicalFilter,
} from "@refinedev/core";
import { AxiosInstance } from "axios";
import { config } from "config";
import { axiosInstance } from "./axios";
import { ClientsType, PaginationTypes, TableNameType } from "./types";

const ApiUrl = config().server.api;
export const HttpClient: AxiosInstance = axiosInstance;

export const initAuthorization = () => {
  const AuthToken = window.sessionStorage.getItem("authorization");
  HttpClient.defaults.headers = {
    ...axiosInstance.defaults.headers,
    ...{ Authorization: "Bearer " + AuthToken },
  };
};
initAuthorization();

export const handleFilters = (filters?: CrudFilters) => {
  let res = {};
  if (filters) {
    res = filters.reduce((pre, curr) => {
      const { field, value } = curr as LogicalFilter;
      const k = encodeURIComponent(field);
      const v = encodeURIComponent(value);
      return { ...pre, [k]: v };
    }, {});
  }

  return res;
};

export const handleSorters = (sorters?: CrudSorting) => {
  let res = {};
  if (sorters) {
    res = sorters.reduce((pre, curr) => {
      const { field, order } = curr as CrudSort;
      const k = encodeURIComponent(`$sort[${field}]`);
      const v = order.toLowerCase() === "asc" ? "1" : "-1";
      return { ...pre, [k]: v };
    }, {});
  }

  return res;
};

const handlePagination = (pagination?: PaginationTypes) => {
  let res = {};
  if (pagination) {
    res = {
      [encodeURIComponent("$limit")]: pagination.$limit,
      [encodeURIComponent("$skip")]: pagination.$skip,
    };
  }
  return res;
};

export const handleCommonFindRequest = async (
  tableName: TableNameType,
  filters?: CrudFilters,
  sorters?: CrudSorting,
  pagination?: PaginationTypes,
  client?: ClientsType
) => {
  const url = `${ApiUrl}/v2/admin/common-find`;

  try {
    const { data } = await HttpClient.post(url, {
      tableName,
      client,
      ...handleFilters(filters),
      ...handleSorters(sorters),
      ...handlePagination(pagination),
    });
    return data;
  } catch (error: any) {
    handleRequestCatch(error);
  }
};

export const handleCommonGetRequest = async (
  tableName: TableNameType,
  id: string,
  client?: ClientsType
) => {
  const url = `${ApiUrl}/v2/admin/common-get?`;
  const query = `tableName=${tableName}&id=${id}&client=${client}`;

  try {
    const { data } = await HttpClient.get(url + query);
    return data;
  } catch (error: any) {
    handleRequestCatch(error);
  }
};

export const handleCommonDeleteRequest = async (
  tableName: TableNameType,
  id: string,
  client?: ClientsType
) => {
  const url = `${ApiUrl}/v2/admin/common-delete`;

  try {
    const { data } = await HttpClient.delete(url, {
      data: { tableName, id, client },
    });
    return data;
  } catch (error: any) {
    handleRequestCatch(error);
  }
};

export const handleCommonPatchRequest = async (
  tableName: TableNameType,
  id: string,
  value: any,
  client?: ClientsType
) => {
  const url = `${ApiUrl}/v2/admin/common-patch`;

  try {
    const { data } = await HttpClient.patch(url, {
      tableName,
      id,
      client,
      value,
    });
    return data;
  } catch (error: any) {
    handleRequestCatch(error);
  }
};

export const handleCommonCreateRequest = async (
  tableName: TableNameType,
  value: any,
  client?: ClientsType
) => {
  const url = `${ApiUrl}/v2/admin/common-create`;

  try {
    const { data } = await HttpClient.post(url, {
      tableName,
      client,
      value,
    });
    return data;
  } catch (error: any) {
    handleRequestCatch(error);
  }
};

export const handleSettingPatch = async (id: string, data: any) => {
  const res = await handleCommonPatchRequest("settings", id, { value: data });
  return res;
};

export const handleAudioUpload = async (variables: any) => {
  const url = `${ApiUrl}/v2/admin/upload`;
  try {
    const res = await HttpClient.post(url, variables, {
      withCredentials: false,
      headers: {
        awsfolder: "system",
      },
    });
    return res;
  } catch (error: any) {
    handleRequestCatch(error);
  }
};

export const groupIsAdmin = () => {
  const userData = JSON.parse(window.sessionStorage.getItem("user") as string);
  return userData.group == 1;
};

const handleRequestCatch = (error: any) => {
  window.alert(error.message);

  if (error.statusCode === 500) {
    sessionStorage.removeItem("authorization");
    sessionStorage.removeItem("user");
    window.location.href = "/login";
  }
};

export const batchPatchUserBadgeExpirationDate = async (
  tableName: TableNameType,
  value: any
) => {
  const url = `${ApiUrl}/v2/admin/common-patch`;
  try {
    const { data } = await HttpClient.patch(url, {
      tableName,
      id: "",
      value,
    });
    return data;
  } catch (error: any) {
    handleRequestCatch(error);
  }
};

const updateServerHpa = async (url: string) => {
  try {
    const data = await HttpClient.post(url);
    console.log("HPA response:", data);
  } catch (error) {
    console.error("Error updating HPA:", error);
  }
};

export const handleHpa = async (variables: any) => {
  const { currentServer, value } = variables;
  if (currentServer === value) return;

  const servers = config().scannerServers;
  const needDown = servers.find((item) => item.value === currentServer);
  const needUp = servers.find((item) => item.value === value);

  if (needDown?.down) {
    await updateServerHpa(needDown.down);
  }

  if (needUp?.up) {
    await updateServerHpa(needUp.up);
  }
};
